/**
 * GraphExplorer Type Definitions
 *
 * This file centralizes all types used by the GraphExplorer section.
 * It re-exports external types and defines local types to provide a single
 * import point for components.
 */

import React from 'react';

import type { GraphEntityType } from '@/components/nodeGraph/utils/types';
import type { SeedFilter } from '@/sections/seeds';
import { AssetStatus } from '@/types';

// Re-export external types for convenience
export type { GraphEntityType, SeedFilter };

/**
 * Asset filter configuration for GraphExplorer
 * Matches the filters used by AssetTableFilters component
 */
export interface AssetFilters {
  search?: string;
  advancedFilters?: {
    // Asset Attribute filters
    new?: string[];
    cloud?: string[];
    port?: string[];
    protocol?: string[];
    tags?: string[];
    // Asset module filters
    asname?: string[];
    asnumber?: string[];
    status?: AssetStatus[];
    class?: string[];
    attackSurface?: string[];
    source?: string[];
    origins?: string[];
  };
}

/**
 * Union type representing all possible filter types in GraphExplorer
 */
export type Filters = AssetFilters | SeedFilter;

/**
 * Props for EntitySearchFilters component
 */
export interface EntitySearchFiltersProps {
  entityType: GraphEntityType;
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
}

/**
 * Type guard to check if filters are SeedFilter
 */
export function isSeedFilter(filters: Filters): filters is SeedFilter {
  return 'type' in filters;
}

/**
 * Type guard to check if filters are AssetFilters
 */
export function isAssetFilters(filters: Filters): filters is AssetFilters {
  return !('type' in filters);
}
